import { render, staticRenderFns } from "./TicketTab.vue?vue&type=template&id=624890b6&"
import script from "./TicketTab.vue?vue&type=script&lang=js&"
export * from "./TicketTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports